import { useContext } from 'react';

import { InventoryContext } from '@shared/components/inventory_capture/inventory_context';
import { filterInventoryForSave } from '@shared/utils/filter_inventory_for_save';

export const useInventoryForSave = () => {
  const { data } = useContext(InventoryContext);

  return filterInventoryForSave(data);
};
